export default "__VITE_ASSET__BX5q8N9F__"